<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <label>
          Verify Credit Card
        </label>
        <el-tooltip class="item" effect="dark" content="The credit card number you entered below will not be saved. This is only for verifying that the value is a valid credit card number." placement="right-end">
          <img class="icon-info m-left-4" src="static/img/icon-info.png" />
        </el-tooltip>
        <el-input type="number"
                  name="creditCardNum"
                  placeholder="Credit Card #"
                  v-model="creditCardNum"
                  clearable />
      </div>
      <div v-if="creditCardNum" class="col-md-1 no-padding" style="margin-top: 25px;">
        <el-tooltip class="item space-icon" effect="dark" :content="luhnTooltipContent" placement="top-start">
          <img class="icon luhn-result"
               :src="`static/img/active-${luhnsCheckPassed}.png`"
                :alt="luhnsCheckPassed ? 'pass' : 'fail'"/>
        </el-tooltip>
      </div>
      <div v-if="luhnsCheckPassed" class="col-md-3 no-padding" style="margin-top: 25px;">
        <el-tooltip class="item space-icon" effect="dark" :content="cardTypeTooltipContent" placement="top-start">
          <img class="icon"
               :alt="cardType"
               :src="`static/img/cc-${cardType}.png`"
               height="30px"
               style="margin-top:7px;"/>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
const VISA = "visa"
const AMEX = "amex"
const MASTERCARD = "mastercard"
const DINERSCLUB = "dinersclub"
const DISCOVER = "discover"
const UNKNOWN = "unknown"

export default {
  computed: {
    luhnsCheckPassed() {
      if (!this.creditCardNum || this.creditCardNum.length < 13) {
        return false
      }

      let checkSum = 0;
      for (let i = 1; i <= this.creditCardNum.length; i++) {
        const digit = parseInt(this.creditCardNum.charAt(this.creditCardNum.length - i));
        if (i % 2 === 0) {
          const productString = (digit * 2).toString()
          for (let j = 0; j < productString.length; j++) {
            checkSum += parseInt(productString.charAt(j));
          }
        } else {
          checkSum += digit;
        }
      }
      return checkSum % 10 === 0;
    },
    luhnTooltipContent() {
      if (this.luhnsCheckPassed) {
        return "Luhn's check passed"
      }
      return "Luhn's check failed"
    },
    cardType() {
      const num = this.creditCardNum
      if (!num) { return }

      const length = num.length

      if ((length === 13 || length === 16) && num.charAt(0) === '4') {
        return VISA
      }
      if (length === 14 && num.charAt(0) === '3' && ['0', '6', '8'].includes(num.charAt(1))) {
        return DINERSCLUB
      }
      if (length === 16 && num.charAt(0) === "6") {
        return DISCOVER
      }
      if (length === 15 && num.charAt(0) === '3' && ['4', '7'].includes(num.charAt(1))) {
        return AMEX
      }
      if (length === 16 &&
        (num.charAt(0) === '5' && ['1', '2', '3', '4', '5'].includes(num.charAt(1))
          || num.charAt(0) === '2' && ['2', '3', '4', '5', '6', '7'].includes(num.charAt(1)))) {
        return MASTERCARD
      }
      return UNKNOWN
    },
    cardTypeTooltipContent() {
      switch(this.cardType) {
        case VISA: {
          return "Valid VISA card number"
        }
        case DINERSCLUB: {
          return "Valid Diner's Club card number"
        }
        case DISCOVER: {
          return "Valid Discover card number"
        }
        case AMEX: {
          return "Valid American Express card number"
        }
        case MASTERCARD: {
          return "Valid Mastercard card number"
        }
        case UNKNOWN: {
          return "Unknown card type. This number may be valid but is not a VISA, Mastercard, AMEX, Discover or Diner's Club card"
        }
      }
    }
  },
  data() {
    return {
      creditCardNum: null,
    }
  }
}
</script>
<style scoped>
.luhn-result {
  max-width:70%;
  margin-top:5px;
}
.no-padding {
  padding:0
}
</style>
